import Icon from '@mui/material/Icon';

export default ({icon}) => {
    if (!icon) return <></>
    if (icon.includes('emoji:')) return <span className='icon'>{icon.substring(6)}</span>
    return <Icon>{icon}</Icon>
}